module.exports = __webpack_public_path__ + "static/media/efficiency-rafiki-business.7561f6b6.svg";